/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import BackButton from "../../../assets/Vector/BackButton.svg";
import { SERVICES } from "../Services";
import { get } from "../ApiHandler/apihandler";

const MainContainer = styled.div`
  display: flex;
  padding: 16px 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  // margin: 0 24px;
  margin: 24px 24px 0px 24px;
`;
const Text = styled.p`
  color: #4c4e8d;
  font-family: Noto Sans;
  font-size: 18px;
  font-weight: 500;
  margin: 0 0;
`;
function Heading({ title }) {
  const [profileData, setProfileData] = useState({});
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/");
  };
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
      // if (response.status === 403) {
      //   dispatch(logoutAction());
      // } else {
      //   console.error("Failed to fetch Division Type data");
      // }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    getUserRole();
  }, []);
  return (
    // <div>Heading</div>
    <MainContainer>
      {profileData?.assignedRoles?.includes("contributionAdmin") && (
        <img
          src={BackButton}
          alt="/backbutton"
          onClick={handleBack}
          style={{ cursor: "pointer" }}
        />
      )}
      {/* <img
        src={BackButton}
        alt="/backbutton"
        onClick={handleBack}
        style={{ cursor: "pointer" }}
      /> */}
      <Text>{title}</Text>
    </MainContainer>
  );
}

export default Heading;
